module.exports = __webpack_public_path__ + "static/media/IMG_0742.f288b003.jpg";